import { supabaseClient } from "@/lib/database/supabase";
import getRouteForCrew from "@/lib/utils/route/getRouteForCrew";
import { InsertCrewWithCommissionerArgs } from "@shared/lib/database/function.types";
import { CrewSummary, PublicCrewProfile } from "@shared/lib/database/query.types";
import { defineStore } from "pinia";
import { ref } from "vue";
import useModalStore from "./useModalStore";

export default defineStore("CrewStore", () => {
  const {
    openModal,
  } = useModalStore();

  const crewMap = ref<Map<string, CrewSummary | PublicCrewProfile>>(new Map());
  function getCrew (crewId: string) {
    return crewMap.value.get(crewId) ?? null;
  }

  function setCrew (crewId: string, crew: CrewSummary | PublicCrewProfile) {
    crewMap.value.set(crewId, crew);
  }

  function viewCrew (crew: CrewSummary | PublicCrewProfile) {
    if (!crew.id) return;

    setCrew(crew.id, crew);

    return openModal(getRouteForCrew(crew.id));
  }

  async function createCrew ({
    name,
    location,
  }: InsertCrewWithCommissionerArgs) {
    const {
      data: crew,
    } = await supabaseClient
      .rpc("insert_crew_with_commissioner", {
        name,
        location,
      })
      .throwOnError();

    setCrew(crew.id, crew);

    return crew;
  }

  async function fetchCrew (crewId: string) {
    const {
      data: _crew,
    } = await supabaseClient
      .rpc("get_public_crew_profile", {
        crew_id: crewId,
      })
      .maybeSingle()
      .throwOnError();

    if (_crew) {
      const crew = _crew as PublicCrewProfile;
      setCrew(crewId, crew);
      return crew;
    }
  }

  return {
    getCrew,
    setCrew,
    viewCrew,
    createCrew,
    fetchCrew,
  };
});
